<template>
  <el-table ref="singleTable" :data="allData" :max-height="tableHeight1" stripe style="width: 100%">
    <el-table-column type="index" width="50" label="  ">
      <template slot-scope="scope">
        <span>{{scope.$index+index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column width="180" property="name" label="企业名称" align="center">
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.isDecryption"
          placement="top"
          content="点击解密">
          <span @click="clickRow(scope.row)">{{scope.row.companyName}}</span>
        </el-tooltip>
        <span v-else>{{scope.row.companyNameDecryption}}</span>
      </template>
    </el-table-column>
    <el-table-column width="180" property="companyAddrss" label="地址" align="center"></el-table-column>
    <el-table-column width="100" property="vehicleNumDesc" label="企业旗下总车辆数" align="center"></el-table-column>
    <el-table-column width="100" property="inProvinceMileRate" label="省内运营里程占比 %" align="center"></el-table-column>
    <el-table-column width="120" property="countryAllMileDesc" label="全国运营里程" align="center"></el-table-column>
    <el-table-column label="运营省内分品牌加油站停靠次数" align="center">
      <el-table-column
          property="inProvinceStopAll"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="inProvinceStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="inProvinceStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="inProvinceStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
    <el-table-column label="全国省内分品牌加油站停靠次数" align="center">
      <el-table-column
          property="countryStopAll"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="countryStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="countryStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="countryStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
  </el-table>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import get from 'lodash/get'
export default {
  props: {
    allData: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      tableHeight1:this.tableHeight+120,
    }
  },
  methods: {
    clickRow(obj){
      obj.isDecryption=false;
      this.onDecryption(obj);
    },
    onDecryption(obj) {
      let id=obj.id;
      let param = {id};
      http
        .wayRoadDecrypt(param)
        .then(e => {
          if(e.code===200){
            obj.companyNameDecryption=""+get(e,"data.companyName","")
          }
        })
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  },
}
</script>